export default __webpack_public_path__ + "static/media/ico-alert-danger.cdea8256.svg";